import React from "react";
import styled from "styled-components";

interface ProfilePictureProps {
  imageUrl: string;
  altText: string;
}

const ProfilePicture: React.FC<ProfilePictureProps> = ({ imageUrl, altText }) => {
  return (
    <ProfilePictureWrapper>
      <Picture src={imageUrl} alt={altText} />
    </ProfilePictureWrapper>
  );
};

const ProfilePictureWrapper = styled.div`
  float: right;
  margin: 10px 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid ${({ theme }) => theme.textColor};
`;

const Picture = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export default ProfilePicture;
